import { Component, EventEmitter, Input, Output } from '@angular/core';

import { CommonForm } from "../common-form/common-form";
import { KEY_PERSONNEL_DETAILS_FORM_KEYS } from '../../../../../shared/utils/constants';
import { KeyPersonnelFormKey } from '../../../../../shared/utils/types';
import { Header } from '../../../../../core/services/header';

@Component({
  selector: 'app-executive-management',
  imports: [CommonForm],
  templateUrl: './executive-management.html',
  styleUrl: './executive-management.css'
})
export class ExecutiveManagement {
  @Input() data: any;
  @Output() closeCurrentForm = new EventEmitter<any>();

  activeForm: KeyPersonnelFormKey = KEY_PERSONNEL_DETAILS_FORM_KEYS.EXECUTIVE_MANAGEMENT;


  constructor(private headerService: Header) {

  }

  ngOnInit(): void {
    //Set header configs
    this.headerService.updateConfig({
      title: 'Executive management',
      showNotifications: false,
      showRightSection: false,
      dropdownOptions: []
    });
  }

  ngOnDestroy(): void {
    this.headerService.resetConfig();
  }



  handleFormSubmission(formData: any) {
    // console.log("Received form data:", formData);

    //todo handle api calls
    this.closeCurrentForm.emit();
  }
}
